import { render, staticRenderFns } from "./proposal-pane.vue?vue&type=template&id=4918f0b4"
import script from "./proposal-pane.vue?vue&type=script&lang=js"
export * from "./proposal-pane.vue?vue&type=script&lang=js"
import style0 from "./proposal-pane.vue?vue&type=style&index=0&id=4918f0b4&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4918f0b4')) {
      api.createRecord('4918f0b4', component.options)
    } else {
      api.reload('4918f0b4', component.options)
    }
    module.hot.accept("./proposal-pane.vue?vue&type=template&id=4918f0b4", function () {
      api.rerender('4918f0b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/ssr-manage/proposal-pane.vue"
export default component.exports